import React from 'react';
import './About.css';

class About extends React.Component {
  render() {
    return (
      <div className="container citation">
        <h2>Methodology</h2>
        <p>Thalamic nuclei were labeled using retrograde viral or tracer injection from their target area in cortex or striatum. Anterograde labeling was used to separate adjacent nuclei (e.g. VL and VA) based on their different inputs. Approximately 50-100 cells were manually sorted for each nucleus followed by library prep and sequencing. For analysis, reads were mapped to the mouse genome and exon-mapping reads were counted for each gene for downstream analysis in R.</p>
        <p>For single-cell RNAseq, thalamic cells projecting to 5 major cortical target areas (motor, somatosensory, visual, auditory, and prefrontal cortex) were manually picked. For library preparation, cellular and molecular barcodes were added, followed by PCR amplification, tagmentation, and sequencing. For analysis, a modified Drop-seq_tools pipeline was applied. Single-cell clusters were defined using Seurat.</p>
        <p>For additional details see the citation below.</p>
        <p>Differential gene expression tests on this website are done using the limma R package.</p>

        <h2>Citation</h2>
        <h4>A repeated molecular architecture across thalamic pathways</h4>
          <i>James W. Phillips, Anton Schulmann, Erina Hara, Johan Winnubst, Chenghao Liu, Vera Valakh, Lihua Wang, Brenda C. Shields, Wyatt Korff, Jayaram Chandrashekar, Andrew L. Lemire, Brett Mensh, Joshua T. Dudman, Sacha B. Nelson & Adam W. Hantman</i>
            <p><b>Nature Neuroscience</b> volume 22, pages 1925–1935 (2019); doi: <a href="https://doi.org/10.1038/s41593-019-0483-3">https://doi.org/10.1038/s41593-019-0483-3</a></p>

        <h2 id="geneselection">Gene Selection Criteria</h2>
        <p>For the pooled-cell nuclei dataset, lowly expressed genes were filtered by requiring a Transcripts per million (TPM) > 10 in at least 3 samples. This yielded a list of approximately 17,000 genes.</p>
        <p>For the single-cell dataset, genes were considered expressed if their expression was detected in more than 10 cells. A full matrix of counts for both datasets is available under the Download tab.</p>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.jsx